import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Clock, Heart } from 'lucide-react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
const listings = [{
  id: 1,
  title: 'iPhone 15 Pro Max 256GB - Like New',
  price: '$1,200',
  location: 'Orchard',
  time: '2 hours ago',
  category: 'Electronics',
  image: 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=400&h=300&fit=crop',
  tag: 'Urgent'
}, {
  id: 2,
  title: 'Master Room for Rent near MRT',
  price: '$850/mo',
  location: 'Tampines',
  time: '4 hours ago',
  category: 'Real Estate',
  image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=300&fit=crop',
  tag: 'Verified'
}, {
  id: 3,
  title: 'Toyota Corolla Altis 2020',
  price: '$68,000',
  location: 'Jurong East',
  time: '5 hours ago',
  category: 'Vehicles',
  image: 'https://images.unsplash.com/photo-1623869675781-80aa31012a5a?w=400&h=300&fit=crop'
}, {
  id: 4,
  title: 'Senior Web Developer Needed',
  price: 'Negotiable',
  location: 'CBD',
  time: '1 day ago',
  category: 'Jobs',
  image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&h=300&fit=crop',
  tag: 'Hiring'
}, {
  id: 5,
  title: 'Yoga Classes for Beginners',
  price: '$15/session',
  location: 'Katong',
  time: '1 day ago',
  category: 'Classes',
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=300&fit=crop'
}, {
  id: 6,
  title: 'Moving Sale - Full Furniture Set',
  price: 'Free',
  location: 'Woodlands',
  time: '2 days ago',
  category: 'For Sale',
  image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=300&fit=crop',
  tag: 'Free'
}];
export function FeaturedListings() {
  return <section className="py-12 bg-[#F5F5F5]" data-id="element-18">
      <div className="container mx-auto px-4" data-id="element-19">
        <div className="flex justify-between items-end mb-8" data-id="element-20">
          <div data-id="element-21">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-22">
              Fresh Recommendations
            </h2>
            <p className="text-gray-600 mt-1" data-id="element-23">
              Handpicked classifieds for you in Singapore
            </p>
          </div>
          <a href="#" className="text-[#00897B] font-medium hover:underline hidden sm:block" data-id="element-24">
            View all listings &rarr;
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {listings.map(listing => <motion.div key={listing.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3
        }} data-id="element-26">
              <Card className="overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer group h-full flex flex-col border-gray-200 hover:border-[#00897B]/30 hover:scale-[1.01]" data-id="element-27">
                <div className="h-48 w-full relative overflow-hidden" data-id="element-28">
                  <img src={listing.image} alt={listing.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-29" />

                  {listing.tag && <span className="absolute top-3 left-3 bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 rounded shadow-sm" data-id="element-30">
                      {listing.tag}
                    </span>}

                  <Button size="icon" variant="ghost" className="absolute top-3 right-3 bg-white/80 hover:bg-white text-gray-500 hover:text-red-500 rounded-full h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-31">
                    <Heart className="h-4 w-4" data-id="element-32" />
                  </Button>
                </div>

                <div className="p-4 flex flex-col flex-1" data-id="element-33">
                  <div className="flex justify-between items-start mb-2" data-id="element-34">
                    <h3 className="font-semibold text-gray-900 line-clamp-2 group-hover:text-[#00897B] transition-colors" data-id="element-35">
                      {listing.title}
                    </h3>
                  </div>

                  <p className="text-xl font-bold text-[#00897B] mb-3" data-id="element-36">
                    {listing.price}
                  </p>

                  <div className="mt-auto flex items-center justify-between text-xs text-gray-500" data-id="element-37">
                    <div className="flex items-center gap-1" data-id="element-38">
                      <MapPin className="h-3 w-3" data-id="element-39" />
                      <span data-id="element-40">{listing.location}</span>
                    </div>
                    <div className="flex items-center gap-1" data-id="element-41">
                      <Clock className="h-3 w-3" data-id="element-42" />
                      <span data-id="element-43">{listing.time}</span>
                    </div>
                  </div>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center sm:hidden" data-id="element-44">
          <Button variant="outline" className="w-full" data-id="element-45">
            View all listings
          </Button>
        </div>
      </div>
    </section>;
}